import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER_SUCCESS,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  GET_AUTHORIZATION_INFO,
  GET_AUTHORIZATION_INFO_COMPLETE,
  GET_AUTHORIZATION_INFO_FAILED,
  GET_PROFILE_INFO,
  GET_PROFILE_INFO_COMPLETE,
  GET_PROFILE_INFO_FAILED,
} from 'constants/ActionTypes';
import storage from '../util/storage';

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  authUser: storage.userId.get(),
  profile: {
    isFetching: false,
    isFetched: false,
  },
  authorization: {
    isFetching: false,
    isFetched: false,
    account: {},
    shopList: [],
    shopMap: {},
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROFILE_INFO: {
      return {
        ...state,
        profile: {
          ...state.profile,
          isFetching: true,
        },
      };
    }

    case GET_PROFILE_INFO_COMPLETE: {
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload,
          isFetching: false,
          isFetched: true,
        },
      };
    }

    case GET_PROFILE_INFO_FAILED: {
      return {
        ...state,
        profile: {
          ...state.profile,
          isFetching: false,
          isFetched: false,
        },
      };
    }

    case GET_AUTHORIZATION_INFO: {
      return {
        ...state,
        authorization: {
          ...state.authorization,
          isFetching: true,
        },
      };
    }

    case GET_AUTHORIZATION_INFO_COMPLETE: {
      return {
        ...state,
        authorization: {
          ...state.authorization,
          ...action.payload,
          isFetching: false,
          isFetched: true,
        },
      };
    }

    case GET_AUTHORIZATION_INFO_FAILED: {
      return {
        ...state,
        authorization: {
          ...state.authorization,
          isFetching: false,
          isFetched: false,
        },
      };
    }

    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload,
      };
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        initURL: '/app/sample-page',
        loader: false,
      };
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false,
      };
    }

    case SIGNIN_GOOGLE_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case SIGNIN_FACEBOOK_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case SIGNIN_TWITTER_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case SIGNIN_GITHUB_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }
    default:
      return state;
  }
};
